// extracted by mini-css-extract-plugin
export default {"no-data":"NoData_no-data__zr-xr"};